import ProfileAPICall from "../service/ProfileAPICall";

class ProfileRepository {
    // Profile
    getProfileAccountInformation = async () => { // Not in used now
        return await new ProfileAPICall().getProfileAccountInformation();
    };

    fetchCarrierData = async (params) => {
        const carrierDataList = await new ProfileAPICall().fetchCarrierData(params);
        await carrierDataList?.res?.intl?.length > 0 && carrierDataList?.res?.intl?.sort((a, b) => a.carrierKey.localeCompare(b.carrierKey));
        return carrierDataList
    };

    setContactData = async (params) => {
        return await new ProfileAPICall().setContactData(params);
    };

    getJobFunctionList = async () => {
        return await new ProfileAPICall().getJobFunctionListData();
    };

    getHeaderAccountList = async () => {
        return await new ProfileAPICall().getHeaderAccountList();
    };

    setAccountAddressDefault = async (data) => {
        return await new ProfileAPICall().setAccountAddressDefault(data);
    };

    setAccountLinkData = async (params) => {
        return await new ProfileAPICall().setAccountLinkData(params);
    };

    profileAddress = async (params, type) => {
        return await new ProfileAPICall().profileAddress(params, type);
    };

    getCountryList = async () => {
        return await new ProfileAPICall().getCountryList();
    };

    getStateList = async (countryCode) => {
        return await new ProfileAPICall().getStateList({ countryCode });
    };

    setAccountLinkData = async (params) => {
        return await new ProfileAPICall().setAccountLinkData(params);
    };

}

export default ProfileRepository;